import { Route, Routes } from 'react-router-dom';
import InventoryItemList from "../../../InventoryItem/InventoryItemList";
import EditInventory from "../../../InventoryItem/EditInventory";
import styled from '@emotion/styled';

const Container = styled.div`
  margin-top: 1.5rem;
`;

const Items = () => {
  return (
    <Container>
      <Routes>
        <Route path="/items" element={<InventoryItemList category="items" />} />
        <Route path="/items/edit/:id" element={<EditInventory category="items" />} />
        <Route path="/items/edit" element={<EditInventory category="items" />} />
      </Routes>
    </Container>
  )
};

export default Items;